import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class LoginService {
  constructor(private http: Http) { }

  login(model: any) {

    let body: string = JSON.stringify(model);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Login/GetLoginDetails', body, options)
      .map((res: Response) => res.json());
  }

  ResetPassword(model: any) {
    let body: string = JSON.stringify(model);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Login/Get_ResetMailId', body, options)
      .map((res: Response) => res.json());
  }
  getTempPass(model: any) {
    let body: string = JSON.stringify(model);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Login/Get_TempPass', body, options)
      .map((res: Response) => res.json());
  }

  UpdatePassword(model: any) {
    let body: string = JSON.stringify(model);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Login/UpdatePassword', body, options)
      .map((res: Response) => res.json());
  }
  UpdateResetPassword(model: any) {
    let body: string = JSON.stringify(model);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Login/UpdateResetPassword', body, options)
      .map((res: Response) => res.json());
  }

  logout() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Login/Logout', {}, options)
      .map((res: Response) => res.text() ? res.json() : {});
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/LoginService.ts